import moment from 'moment';
import {
  AGENT_MANAGEMENT_INIT_FILTERS_FROM_URL,
  AGENT_MANAGEMENT_UPDATE_FILTERS,
  AGENT_MANAGEMENT_RESET_FILTERS,
  AGENT_MANAGEMENT_SET_FILTERS_INITIALIZED,
} from '../actions/constants';
import { BaseTableFilter } from '../components/pages/AgentManagement/components/TasksTabsContainer/hooks/useTableFilters';

export interface AgentManagementState {
  filterState: BaseTableFilter;
  hasFiltersInitializedFromUrl: boolean;
}

const defaultFilterState: BaseTableFilter = {
  selectedAgents: [],
  sortBy: undefined,
  orderBy: undefined,
  currentPage: 1,
  selectedStatus: [],
  dateRange: [moment(), moment()],
};

const defaultState: AgentManagementState = {
  filterState: defaultFilterState,
  hasFiltersInitializedFromUrl: false,
};

export default function agentManagementReducer(
  state: AgentManagementState = defaultState,
  action: any,
): AgentManagementState {
  switch (action.type) {
    case AGENT_MANAGEMENT_INIT_FILTERS_FROM_URL: {
      return {
        ...state,
        filterState: {
          ...defaultFilterState,
          ...action.filters,
        },
        hasFiltersInitializedFromUrl: true,
      };
    }

    case AGENT_MANAGEMENT_UPDATE_FILTERS: {
      return {
        ...state,
        filterState: {
          ...state.filterState,
          ...action.filters,
        },
      };
    }

    case AGENT_MANAGEMENT_RESET_FILTERS: {
      return {
        ...state,
        filterState: {
          ...defaultFilterState,
          dateRange: state.filterState.dateRange,
        },
      };
    }

    case AGENT_MANAGEMENT_SET_FILTERS_INITIALIZED: {
      return {
        ...state,
        hasFiltersInitializedFromUrl: action.initialized,
      };
    }

    default:
      return state;
  }
}

